/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Assessment_Not_AssessableInputs */

const en_directory_agent_readiness_assessment_not_assessable = /** @type {(inputs: Directory_Agent_Readiness_Assessment_Not_AssessableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not be assessed`)
};

const zh_directory_agent_readiness_assessment_not_assessable = /** @type {(inputs: Directory_Agent_Readiness_Assessment_Not_AssessableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法完成评测`)
};

/**
* | output |
* | --- |
* | "Could not be assessed" |
*
* @param {Directory_Agent_Readiness_Assessment_Not_AssessableInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_assessment_not_assessable = /** @type {((inputs?: Directory_Agent_Readiness_Assessment_Not_AssessableInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Assessment_Not_AssessableInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_assessment_not_assessable(inputs)
	return zh_directory_agent_readiness_assessment_not_assessable(inputs)
});
export { directory_agent_readiness_assessment_not_assessable as "directory.agent_readiness.assessment.not_assessable" }